import React from 'react'

import { IntroBlockHeaderForm } from './IntroBlockHeaderForm/IntroBlockHeaderForm'
import { IntroBlockHeaderLogo } from './IntroBlockHeaderLogo/IntroBlockHeaderLogo'

import s from './IntroBlockHeader.module.scss'

export type IntroBlockHeaderProps = {
  name: string
  icon: string
}

export const IntroBlockHeader: React.FC<IntroBlockHeaderProps> = ({
  name,
  icon,
}) => {
  return (
    <div className={s.IntroBlockHeader}>
      <IntroBlockHeaderForm name={name} />
      {icon && <IntroBlockHeaderLogo icon={icon} />}
    </div>
  )
}
